import { Model, MapTo } from 'src/app/decorators/mapto';

export class OrgTypesModel extends Model {
    @MapTo()
    id: number;
    @MapTo()
    name: string;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
